import {
  isCallReadyFindingsV1Enabled,
  isDecisionFindingsV1Enabled,
} from './runtimeFlags';

/**
 * The site tab that hosts the live decision and the Decide surface (record,
 * review, what still holds GO).
 *
 * The promoted Decision tab exists only when BOTH Findings flags are on (the
 * same `splitDecisionSurfacesEnabled` composition SiteLandingPage renders).
 * In a rolled-back build Decide renders under Analyses / Reports instead, and
 * a `?tab=decision` URL would fall back to Home — so links from outside the
 * site page (dashboard, report reader) resolve the tab through this helper
 * rather than hard-coding `'decision'`.
 *
 * Path to GO removal, stage 2: these links used to open the Path to GO tab.
 */
export function siteDecisionTab(): 'decision' | 'reports' {
  return isDecisionFindingsV1Enabled() && isCallReadyFindingsV1Enabled()
    ? 'decision'
    : 'reports';
}
